import { Row, RowProps } from "./Row";

export type ColumnProps = RowProps;

/**
 * @deprecated 代わりにCSSを書いてください。
 */
export const Column = ({ alignItems = "streach", ...props }: ColumnProps) => (
  <Row direction="column" {...props} alignItems={alignItems} />
);
